// import React from 'react'

import { dotmatrix, printList, printPos, wsClient } from "helper/dotmatrix";
// import { getUrl } from "libs/pdf";
// import modalReceipt from 'helper/modalReceipt'
// import {toJpeg} from 'libs/converter'
import moment from "moment";
import { fnumber } from "helper/Helper";
import receiptToArray from "./receiptToArray";
const EscPosEncoder = require("esc-pos-encoder");
const encoder = new EscPosEncoder();
const secureStorage = require("libs/secureStorage");

const printThermal = (payload) => {
  //let receipt = encoder.initialize()
  const user = secureStorage.getItem("account");
  const info = secureStorage.getItem("domainInfo");
  // console.log({ user, info });
  const title = payload.title;
  const body = !Array.isArray(payload.body)
    ? receiptToArray(payload.body)
    : payload.body;
  body.push([`Loket : ${user.name}`]);
  body.push([`Powered by ${info ? info.appName : ""}`]);
  // const spaceLength = spaceNum(payload.body)
  let wholeLine = "";
  for (const item of body) {
    const line = Array.isArray(item)
      ? item.length > 1
        ? item[0].toString().padEnd(15, " ") +
          ": " +
          (typeof item[1] !== "number"
            ? item[0] === "TGL TRANSAKSI"
              ? // ? item[1]
                moment(item[1]).format("DD/MM/YY HH:mm")
              : item[1]
            : "Rp. " + fnumber(item[1]).padStart(9, " "))
        : item[0]
      : item;
    wholeLine += line + "\n";
    //receipt.line(line)
  }
  // console.log(wholeLine)
  const receipt = encoder
    .initialize()
    .newline("center")
    .bold(true)
    .text(title)
    .bold(false)
    .align("left")
    .newline()
    .newline()
    .line(wholeLine)
    .newline()
    .newline()
    .cut("partial")
    .encode();
  if (navigator.bluetooth) {
    // navigator.bluetooth
    //   .requestDevice({
    //     acceptAllDevices: true,
    //     // optionalServices: ["000018f0-0000-1000-8000-00805f9b34fb"],
    //   })
    //   .then((device) => {
    //     return device.gatt.connect();
    //   })
    //   .then((server) => {
    //     return server.getPrimaryServices();
    //   })
    //   .then((services) => {
    //     if (services.length > 0) {
    //       return services[0].getCharacteristics();
    //     } else throw Error("Service not support");
    //   })
    //   .then((characteristics) => {
    //     const chara = characteristics.find((char) => char.properties.write);
    //     if (!chara) throw Error("Device not support");
    //     return chara;
    //   })
    //   .then(async (chara) => {
    //     const maxSize = 20;
    //     let chunkCount = Math.ceil(receipt.byteLength / maxSize);
    //     let index = 0;
    //     const sendChunk = () => {
    //       if (!chunkCount) {
    //         return;
    //       }
    //       const chunk = receipt.slice(index, index + maxSize);
    //       index += maxSize;
    //       chunkCount--;
    //       chara.writeValue(chunk);
    //       setTimeout(() => {
    //         sendChunk();
    //       }, 200);
    //     };
    //     sendChunk();
    //   })
    //   .catch((err) => {
    //     alert(err.message);
    //     return false;
    //   });
    // BACK
    // navigator.bluetooth
    //   .requestDevice({
    //     acceptAllDevices: true,
    //     optionalServices: ["000018f0-0000-1000-8000-00805f9b34fb"],
    //   })
    //   .then((device) => {
    //     return device.gatt.connect();
    //   })
    //   .then((server) => {
    //     return server.getPrimaryService("000018f0-0000-1000-8000-00805f9b34fb");
    //   })
    //   .then((service) => {
    //     return service.getCharacteristic(
    //       "00002af1-0000-1000-8000-00805f9b34fb"
    //     );
    //   })
    //   .then(async (chara) => {
    //     const maxSize = 20;
    //     let chunkCount = Math.ceil(receipt.byteLength / maxSize);
    //     let index = 0;
    //     const sendChunk = () => {
    //       if (!chunkCount) {
    //         return;
    //       }
    //       const chunk = receipt.slice(index, index + maxSize);
    //       index += maxSize;
    //       chunkCount--;
    //       chara.writeValue(chunk);
    //       setTimeout(() => {
    //         sendChunk();
    //       }, 200);
    //     };
    //     sendChunk();
    //   })
    //   .catch((err) => {
    //     alert("[BT Error] " + err.message);
    //     return false;
    //   });
    // Known BLE printer service/characteristic profiles
    const PRINTER_PROFILES = [
      {
        // HPRT, Xprinter, dan sebagian besar printer thermal China
        service: "000018f0-0000-1000-8000-00805f9b34fb",
        characteristic: "00002af1-0000-1000-8000-00805f9b34fb",
      },
      {
        // Rongta, iDPRT, Odi, dan OEM sejenis
        service: "0000ff00-0000-1000-8000-00805f9b34fb",
        characteristic: "0000ff02-0000-1000-8000-00805f9b34fb",
      },
      {
        // Epson TM mobile series
        service: "e7810a71-73ae-499d-8c15-faa9aef0c3f2",
        characteristic: "bef8d6c9-9c21-4c9e-b632-bd58c1009f9f",
      },
      {
        // Woosim, Bixolon, dan beberapa printer SPP-over-BLE
        service: "49535343-fe7d-4ae5-8fa9-9fafd205e455",
        characteristic: "49535343-8841-43f4-a8d4-ecbe34729bb3",
      },
    ];
    const sendChunks = async (chara) => {
      const maxSize = 20;
      let index = 0;
      const useWithoutResponse =
        chara.properties.writeWithoutResponse && !chara.properties.write;
      while (index < receipt.byteLength) {
        const chunk = receipt.slice(index, index + maxSize);
        if (useWithoutResponse) {
          await chara.writeValueWithoutResponse(chunk);
        } else {
          await chara.writeValue(chunk);
        }
        index += maxSize;
        await new Promise((resolve) => setTimeout(resolve, 200));
      }
    };
    const tryProfile = async (server, profile) => {
      const service = await server.getPrimaryService(profile.service);
      const chara = await service.getCharacteristic(profile.characteristic);
      if (!chara.properties.write && !chara.properties.writeWithoutResponse) {
        throw new Error("Characteristic not writable");
      }
      return chara;
    };
    navigator.bluetooth
      .requestDevice({
        acceptAllDevices: true,
        optionalServices: PRINTER_PROFILES.map((p) => p.service),
      })
      .then((device) => device.gatt.connect())
      .then(async (server) => {
        for (const profile of PRINTER_PROFILES) {
          try {
            const chara = await tryProfile(server, profile);
            await sendChunks(chara);
            return;
          } catch (_) {
            // profile ini tidak cocok, coba berikutnya
          }
        }
        throw Error(
          "Printer tidak dikenali. Pastikan printer menyala dan terpasang dengan benar."
        );
      })
      .catch((err) => {
        alert(err.message);
        return false;
      });
  } else {
    throw Error("Perangkat ini tidak mendukung bluetooth");
  }
};
const printDotMatrix = (payload, collective) => {
  dotmatrix(payload, collective);
};

// const printDeskjet = (payload)=>{
//   // const title = payload.title
//   // const body = modalReceipt(payload.body)
//   // console.log(payload)
//   // console.log(payload.ref)
//   const w = window.open();
//   // console.log(payload.ref.current.myRef.current.innerHTML)
//   w && w.document.write(payload.ref.current.myRef.current.innerHTML);
//   w && w.document.close()
//   // w && w.focus()
//   w && w.print();
//   setTimeout(()=>{
//     w && w.close();
//   },100)
// }
const printDeskjet = async (payload) => {
  const { getUrl } = require("libs/pdf");
  const url = await getUrl(payload, "PdfReceipt");
  if (navigator.userAgent.toLocaleLowerCase().indexOf("electron/") !== -1) {
    wsClient.send("deskjet", { url });
  } else {
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = url;
    document.body.appendChild(iframe);
    iframe.contentWindow.print();
  }
};
const printDeskjetList = async (payload) => {
  // const {title,body} = payload
  const url = payload.url;
  if (navigator.userAgent.toLocaleLowerCase().indexOf("electron/") !== -1) {
    wsClient.send("deskjet", { url });
  } else {
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = url;
    document.body.appendChild(iframe);
    iframe.contentWindow.print();
  }
};
const printDeskjetCollective = async (payload) => {
  // console.log(payload)
  const { getUrl } = require("libs/pdf");
  const data = payload;
  const url = await getUrl({ data }, "PdfCollective");
  if (navigator.userAgent.toLocaleLowerCase().indexOf("electron/") !== -1) {
    wsClient.send("deskjet", { url });
  } else {
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = url;
    document.body.appendChild(iframe);
    iframe.contentWindow.print();
  }
};

const print = (payload, collective) => {
  const printer = secureStorage.getItem("printer");
  if (printer === "thermal") printThermal(payload);
  else if (printer === "dotmatrix") printDotMatrix(payload, collective);
  else if (printer === "pos") printPos(payload);
  else {
    if (!collective) printDeskjet(payload);
    else printDeskjetCollective(payload);
  }
};
print.list = (payload) => {
  if (payload.printer === "dotmatrix") printList(payload);
  else printDeskjetList(payload);
};

export default print;
